module.exports = __webpack_public_path__ + "img/4.06.51c78e29.jpg";